module.exports = __webpack_public_path__ + "static/img/list-default.bc65ec20.png";